import React from 'react';


function M5(props){
    return <section className="m5">
        <div className="container">
            <header className="m5_header c1">
                <h1 className="c1_headline">{props.data.title}</h1>
                <p className="c1_subheadline">{props.data.subtitle}</p>
            </header>
            <form className="c4" method="post">
                <div className="m5_columns">
                    <div className="m5_column_left">
                        <div className="form-group">
                            <label className="form-label" htmlFor="contact_name">Your Name</label>
                            <input id="contact_name" name="contact_name" type="text"
                                   aria-describedby="contact_nameHelpBlock" className="form-control" required
                                   placeholder="Jane Doe"/>
                        </div>
                        <div className="form-group">
                            <label className="form-label" htmlFor="contact_email">Email</label>
                            <input id="contact_email" name="contact_email" type="email" className="form-control"
                                   required placeholder="jane.doe@example.com"/>
                        </div>
                        <div className="form-group">
                            <label className="form-label" htmlFor="contact_phone">Phone</label>
                            <input id="contact_phone" name="contact_phone" type="tel" className="form-control"
                                   required placeholder="+1 123 456 7890"/>
                        </div>
                    </div>
                    <div className="m5_column_right">
                        <div className="form-group">
                            <label className="form-label" htmlFor="contact_message">Message</label>
                            <textarea id="contact_message" name="contact_message" className="form-control" required placeholder="Message"/>
                        </div>
                    </div>
                </div>
                <div className="m5_footer">
                    <button name="submit" type="submit" className="button-secondary">Send</button>
                </div>
            </form>
        </div>
    </section>
}

export default M5;
